import React, {useRef} from 'react';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import {connect} from 'react-redux';



function Credit_price(props){
  let requested_credit_menu=useRef(false);
  let amount='...';
  if(props.credit_menu!=undefined && props.credit_menu!='loading' && props.credit_menu.credit_menu[props.service_identifier]!=undefined){amount=(props.field!=undefined)?props.credit_menu.credit_menu[props.service_identifier][props.field]:props.credit_menu.credit_menu[props.service_identifier].credit_amount;}
  if(props.credit_menu==undefined && requested_credit_menu.current==false){
    requested_credit_menu.current=true;
    props.getCreditMenu();
  }
  if(amount!='...' && props.quantity!=undefined){
    amount=amount*props.quantity;
  }
  return(
    <Tooltip title={amount+" credit"}><Typography variant={(props.small==true)?'caption':undefined}><span style={{marginLeft:'2px', marginRight:'1px'}}><img src='/images/logo.png' style={{width:(props.small==true)?'13px':'15px', marginBottom:'-2px'}}/></span><span style={{marginLeft:'2px', marginRight:'2px'}}><b>{amount}</b></span></Typography></Tooltip>
  )
}



export default connect(ss,dd)(Credit_price);

function ss(state){
  return{
    credit_menu:state.account.credit_menu
  }
}


function dd(dispatch){
  return{
    getCreditMenu:()=>{dispatch({type:'REQUEST_GET_CREDIT_MENU'});}
  }
}
